import React, { useEffect, useState } from "react";
import { Alert, notification } from "antd";
import scrollIntoView from "scroll-into-view-if-needed";

const Toast = (props) => {
    const [type, changeType] = useState("success");
    const [message, changeMessage] = useState("success");
    const [visible, changeVisibility] = useState(false);
    const [from, changeFrom] = useState("");

    useEffect(() => {
        changeType(props.type);
        changeMessage(props.message);
        changeVisibility(true);
        changeFrom(props?.from)
        scrollIntoView(document.getElementById(`toast-container`), {
            behavior: "smooth",
            scrollMode: "if-needed",
          });
    }, [props.type, props.message, props.show]);

    useEffect(() => {
        if(visible) {
            setTimeout(() => {
                changeVisibility(false)
            }, props?.visibility || 3000)
        }
    }, [visible])

   

    return (
        visible ? 
        <div className="toast-content">
            <Alert
                message={message}
                type={type}
                showIcon
                closable
                className="custom-toast"
                afterClose={e => changeVisibility(false)}
            />
        </div> : null
    )
}

export default Toast;